<template src="./list.html"></template>

<script>

import TopService from 'Services/TopService';

export default {
  data() {
    return {
      topJPs: [],
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        this.value = value.replace(/(<([^>]+)>)/g, '');
        if (value.length < 500) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 500)}...`;
      }

      return '';
    },
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      const paramsJP = {
        i18n: this.i18n,
      };

      TopService.listIInfoIntern(paramsJP)
        .then((response) => {
          this.topJPs = response.data.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     /* white-space: pre-line; */
};
</style>
